"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BlockedPaymentProvider = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _checkoutUtils = require("@ori/checkout-utils");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _models = require("../../models");
var _utils = require("../../utils");
var _PaymentMethodIcon = require("./PaymentMethodIcon");
var _jsxRuntime = require("react/jsx-runtime");
const DescriptionTypography = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        margin: theme.spacing(2, 0),
        color: theme.palette.grey[400]
    };
});
const HeaderWrapper = (0, _mui.styled)('div')({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    display: 'flex',
    flexWrap: 'wrap'
});
const ProviderName = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        padding: theme.spacing(1, 0),
        marginRight: theme.spacing(3),
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        color: theme.palette.default.light
    };
});
const LazyImageTopIcon = (0, _mui.styled)(_components.LazyImage)({
    display: 'inline-block',
    height: 25,
    objectFit: 'contain',
    marginLeft: 'auto',
    opacity: 0.25,
    ["& .".concat(_components.lazyImageClasses.image)]: {
        width: 'auto'
    }
});
const ErrorIcon = (0, _mui.styled)(_icons.ErrorCircle)((param)=>{
    let { theme } = param;
    return {
        marginRight: theme.spacing(1),
        transform: "rotate(180deg)"
    };
});
const ToggleCardBlocked = (0, _mui.styled)(_components.ToggleCard)((param)=>{
    let { theme } = param;
    return {
        backgroundColor: theme.palette.grey[50]
    };
});
const ReasonLink = (0, _mui.styled)(_mui.Link)((param)=>{
    let { theme } = param;
    return {
        lineHeight: 1.5,
        marginLeft: theme.spacing(1),
        color: theme.palette.grey[900]
    };
});
const Reason = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        margin: theme.spacing(2)
    };
});
const BlockedPaymentProvider = (param)=>{
    let { paymentProviderGroupBlocked } = param;
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const { image, paymentMethodType, description, reasons, id, isVisibleForNewOrder, visibility } = paymentProviderGroupBlocked;
    const providerNameComponent = (0, _react.useRef)(null);
    const [isOpenTooltip, setIsOpenTooltip] = (0, _react.useState)(false);
    const handleProviderNameClick = (0, _react.useCallback)(()=>{
        setIsOpenTooltip((prevState)=>!prevState);
    }, []);
    const handleProviderNameMouseEnter = (0, _react.useCallback)(()=>setIsOpenTooltip(true), []);
    const handleProviderNameMouseLeave = (0, _react.useCallback)(()=>setIsOpenTooltip(false), []);
    if (!(0, _utils.isProviderVisible)(id, visibility, isVisibleForNewOrder)) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ToggleCardBlocked, {
                disabled: true,
                "aria-checked": false,
                role: "checkbox",
                ...getTestIdProps(_models.TestId.BlockedPaymentProvider),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(HeaderWrapper, {
                        ...getTestIdProps(_models.TestId.PaymentLabel),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Tooltip, {
                                open: isOpenTooltip ? (0, _checkoutUtils.isEllipsisActive)(providerNameComponent.current) : false,
                                placement: "top-start",
                                title: paymentProviderGroupBlocked.name,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProviderName, {
                                    ref: providerNameComponent,
                                    onClick: handleProviderNameClick,
                                    onMouseEnter: handleProviderNameMouseEnter,
                                    onMouseLeave: handleProviderNameMouseLeave,
                                    children: paymentProviderGroupBlocked.name
                                })
                            }),
                            image ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(LazyImageTopIcon, {
                                loading: "eager",
                                alt: image.alt,
                                src: image.src
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PaymentMethodIcon.PaymentMethodIcon, {
                                isDisabled: true,
                                paymentMethodType: paymentMethodType
                            })
                        ]
                    }),
                    description ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(DescriptionTypography, {
                        children: description
                    }) : null
                ]
            }),
            reasons.map((reason)=>{
                if (typeof reason === 'string') {
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Reason, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ErrorIcon, {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                                children: reason
                            })
                        ]
                    }, reason);
                }
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Reason, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(ErrorIcon, {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_mui.Typography, {
                            children: [
                                reason.localizedReasonDescription,
                                reason.linkText && reason.url ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReasonLink, {
                                    color: "textSecondary",
                                    href: reason.url,
                                    children: reason.linkText
                                }) : null
                            ]
                        })
                    ]
                }, reason.localizedReasonDescription);
            })
        ]
    });
};
exports.BlockedPaymentProvider = BlockedPaymentProvider;
